import { showSnackbar } from "../ui/toast/snackbarService"

// utils/clipboardUtils.js
export const copyToClipboard = (text, field) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text)
      .then(() => {
        showSnackbar(`${field} copied successfully!`, "success")
      })
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
      showSnackbar(`${field} copied successfully!`, "success")
    } catch (err) {
      showSnackbar("Failed to copy. Please copy manually.", "error");
    }
    document.body.removeChild(textArea);
  }
}


export const copyToClipboardUsingExtention = (data, field) => {
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(data)
      .then(() => showSnackbar(`${field} copied successfully!`, "success"))
      .catch(() => showSnackbar(`Failed to copy data`, "error"));
  } else {
    const textArea = document.createElement("textarea");
    textArea.value = data;
    document.body.appendChild(textArea);
    textArea.select();
    try {
      document.execCommand("copy");
      showSnackbar(`${field} copied successfully!`, "success");
    } catch (err) {
      showSnackbar("Failed to copy. Please copy manually.", "error");
    }
    document.body.removeChild(textArea);
  }
}
